import { useEffect, useState } from "react";
import { Facebook, Instagram, Youtube } from "lucide-react";

export const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor"><path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.59 2.59 0 0 1 0-5.18c.27 0 .53.04.77.12V9.68a5.7 5.7 0 0 0-.77-.05A5.68 5.68 0 1 0 15.54 15.3V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.3 4.3 0 0 1-3.24-1.48z" /></svg>
);
export const XLogo = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2H21.5l-7.5 8.57L22.8 22h-6.9l-5.4-7.06L4.3 22H1l8.03-9.18L.6 2h7.07l4.88 6.45L18.244 2zm-1.21 18h1.9L6.98 3.9H4.94L17.03 20z" /></svg>
);

export const SOCIAL_NETWORKS = [
  { id: "facebook", label: "Facebook", Icon: Facebook, placeholder: "facebook.com/critterposts" },
  { id: "instagram", label: "Instagram", Icon: Instagram, placeholder: "instagram.com/critterposts" },
  { id: "tiktok", label: "TikTok", Icon: TikTokIcon, placeholder: "tiktok.com/@critterposts" },
  { id: "x", label: "X", Icon: XLogo, placeholder: "x.com/critterposts" },
  { id: "youtube", label: "YouTube", Icon: Youtube, placeholder: "youtube.com/@critterposts" },
];

export const SocialIcons = () => {
  const [links, setLinks] = useState({});
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site/social`).then((r) => r.json()).then(setLinks).catch(() => {});
  }, []);
  const shown = SOCIAL_NETWORKS.filter((n) => links[n.id]);
  if (!shown.length) return null;
  return (
    <div className="flex gap-2 mt-4" data-testid="footer-social">
      {shown.map(({ id, label, Icon }) => (
        <a key={id} href={links[id]} target="_blank" rel="noopener noreferrer" aria-label={label} data-testid={`footer-social-${id}`}
          className="h-9 w-9 rounded-full bg-white/10 hover:bg-[#F5551E] flex items-center justify-center transition-colors">
          <Icon size={17} />
        </a>
      ))}
    </div>
  );
};
